<template>
  <div class="col-span-12 m:col-span-4 bg-pale-mint-grey p-6 l:p-4 mb-7 l:mb-5 rounded">
    <component :is="imageComponent" class="w-xs" />
    <b-headline type="h4" typography="h4" class="pt-4 pb-0 mb-2" v-html="content.title" />
    <b-paragraph class="pt-0" :no-margin="true">
      {{ $t(content.subtitle) }}
    </b-paragraph>
  </div>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
import SharingImage from "@/pages/organisations/components/connect/sharing-image"
import WritingImage from "@/pages/organisations/components/connect/writing-image"
import ConnectPrivacy from "@/pages/organisations/components/connect/connect-privacy"
import BParagraph from "@/component-library/b-paragraph"

export default {
  name: "ValueColumn",
  components: {
    BHeadline,
    SharingImage,
    ConnectPrivacy,
    WritingImage,
    BParagraph
  },
  props: {
    illustration: {
      type: String,
      default: ""
    },
    content: {
      type: Object,
      default: () => {},
      validator: (value) => {
        return Object.keys(value).includes("title") && Object.keys(value).includes("subtitle")
      }
    }
  },
  computed: {
    imageComponent() {
      if (this.illustration === "sharing") {
        return SharingImage
      } else if (this.illustration === "writing") {
        return WritingImage
      } else if (this.illustration === "juggle") {
        return ConnectPrivacy
      } else {
        return ConnectPrivacy
      }
    }
  }
}
</script>
